import React, { useEffect } from 'react';
import { Alert } from '@greatmindsorg/atomic-ui-lib-lts/dist/components/molecules/Alert/Alert.component';

import { useToast } from '~/lib/hooks/useToast';
import * as Styled from './Toast.styled';

export const Toast = () => {
  const { closeToast, toastProps } = useToast();
  const { handleClose, visible, ...toastValues } = toastProps;

  const onClose = e => {
    if (handleClose) handleClose(e);
    closeToast();
  };

  useEffect(() => {
    if (visible) (document.querySelector('[data-testid="test-close-btn"]') as HTMLElement)?.focus();
  }, [visible]);

  return (
    <Styled.Toast>
      {visible && <Alert alertType="toast" {...toastValues} handleClose={onClose} />}
    </Styled.Toast>
  );
};
